import React, { useEffect } from 'react';
import "./globals.css";
import Footer from "./components/Footer";
import NavigationBar from "./components/NavigationBar";

const Sponsorship = () => {
  useEffect(() => {
    document.title = "IWPFI2026_Sponsorship";
  }, []);
  return (
    <div id="everything">
      <NavigationBar />

      <main className="page-sponsorship">
        {/* Header */}
        <section className="sponsorship-section">
          <h1 className="sponsorship-title">Sponsorship Opportunities</h1>
          <p className="sponsorship-intro">
            Support from industry partners plays a vital role in the success of our conference.
            IWPFI 2026 offers a range of sponsorship opportunities that support the meeting and
            provide high visibility within the pulmonary functional imaging community. If you are
            interested to support this conference, please contact Chantal Goddard at{" "}
            <strong>
              <a href="mailto:cgoddard@goddardcom.com">
                cgoddard@goddardcom.com
              </a>
            </strong>
          </p>

        </section>

        {/* Sponsorship Packages */}
        {/* <section className="sponsorship-section">
          <h2>Sponsorship Packages</h2>

          <div className="sponsorship-grid">
            <div className="sponsorship-card">
              <h3>Platinum Sponsor</h3>
              <p className="sponsorship-amount">$50,000 each</p>
              <p className="sponsorship-note">(up to three different sponsors)</p>
            </div>

            <div className="sponsorship-card">
              <h3>Gold Sponsor</h3>
              <p className="sponsorship-amount">$30,000 each</p>
              <p className="sponsorship-note">(up to four different sponsors)</p>
            </div>

            <div className="sponsorship-card">
              <h3>Silver Sponsor</h3>
              <p className="sponsorship-amount">$15,000 each</p>
              <p className="sponsorship-note">(up to five different sponsors)</p>
            </div>

            <div className="sponsorship-card">
              <h3>Friend of IWPFI</h3>
              <p className="sponsorship-amount">$5,000 each</p>
              <p className="sponsorship-note">(unlimited sponsors)</p>
            </div>
          </div>
        </section> */}

        {/* Benefits Comparison Table */}
        {/* <section className="sponsorship-section">
          <h2>Sponsorship Benefits</h2>

          <div className="program-table-wrapper">
            <table className="program-table sponsorship-table">
              <thead>
                <tr>
                  <th></th>
                  <th className="text-center">Platinum</th>
                  <th className="text-center">Gold</th>
                  <th className="text-center">Silver</th>
                  <th className="text-center">Friend of IWPFI</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Up to 3/1* free registrations</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓*</td>
                  <td className="text-center">—</td>
                </tr>
                <tr>
                  <td>Unlimited attendance with registration</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓</td>
                </tr>
                <tr>
                  <td>Early Riser Breakfast</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">—</td>
                  <td className="text-center">—</td>
                  <td className="text-center">—</td>
                </tr>
                <tr>
                  <td>Breakout Session</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">—</td>
                  <td className="text-center">—</td>
                  <td className="text-center">—</td>
                </tr>
                <tr>
                  <td>Welcome Event</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">—</td>
                  <td className="text-center">—</td>
                  <td className="text-center">—</td>
                </tr>
                <tr>
                  <td>Booth space</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓</td>
                </tr>
                <tr>
                  <td>Networking</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓</td>
                  <td className="text-center">✓</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="sponsorship-footnote">
            *Number of free registrations dependent on level and final agreement.
          </p>
        </section> */}
      </main>

      <Footer />
    </div>
  );
};

export default Sponsorship;
